import {Component, OnInit} from '@angular/core';

import {TipoPoder} from '../../../models/tipo-poder.model';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  templateUrl: './listado-tipos-poderes.component.html',
  styleUrls: ['./listado-tipos-poderes.component.css']
})
export class ListadoTiposPoderesComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Inscripción de poderes',
      routerLink: '/poderes'
    }
  ];

  tipos: TipoPoder[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposPoderes().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        // Seleccionando inscripcion de contratos de la funcion getTiposPoderes
        const descripcion = p.descripcion.toString();
          array.push(p);
      });
      this.tipos = array;
    });
  }
}
